import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useLocalStorage } from 'Shared/hooks';
import { useSelectedDatasetId } from 'Datasets/store';
import { MODEL_DEFINITIONS_PATH } from 'Router/consts';
import Link from 'Common/components/Link/Link';
import { isWgsOrWes } from 'Common/utils/isWesWgs/isWesWgs';
import { ModelDefinitionsDataset } from 'ModelDefinitionsView/types';
import { MODEL_DEFINITIONS_DATASET_LOCAL_STORAGE_KEY } from 'ModelDefinitionsView/consts';
import { MODEL_DEFINITIONS_LINK_LABEL } from './consts';
import styles from './LinkToModelDefinitions.css';
const LinkToModelDefinitions = () => {
    const [, setModelDefinitionsDataset] = useLocalStorage(MODEL_DEFINITIONS_DATASET_LOCAL_STORAGE_KEY, ModelDefinitionsDataset.DEFAULT, false);
    const selectedDatasetId = useSelectedDatasetId();
    const handleClick = useCallback((event) => {
        event.stopPropagation();
        if (FEATURE_FLAGS.PUBLIC_VERSION) {
            setModelDefinitionsDataset(isWgsOrWes(selectedDatasetId)
                ? ModelDefinitionsDataset.WES_WGS
                : ModelDefinitionsDataset.DEFAULT);
        }
    }, [setModelDefinitionsDataset, selectedDatasetId]);
    return (_jsx("div", Object.assign({ className: styles.modelLinkWrapper, onClick: handleClick, role: "presentation" }, { children: _jsx(Link, Object.assign({ to: MODEL_DEFINITIONS_PATH, target: "_blank" }, { children: MODEL_DEFINITIONS_LINK_LABEL }), void 0) }), void 0));
};
export default LinkToModelDefinitions;
